import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'app/components/components.module';
import { BlogComponent } from './blog.component';
import { BlogRoute } from './blog.routing';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { DirectivesModule } from '@shared/directive/Directive.module';

@NgModule({
  declarations: [BlogComponent],
  imports: [
    CommonModule,
    BlogRoute,
    ComponentsModule,
    LocalizeRouterModule,
    TranslateModule,
    NgbPaginationModule,
    FontAwesomeModule,
    DirectivesModule,
  ],
})
export class BlogModule {}
